import { css } from "styled-components"


export const creators = css`
  background-color: ${({ theme }) => theme.old.colors.white};
  color: ${({ theme }) => theme.old.colors.primary};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);

  :hover {
    background-color: ${({ theme }) => theme.old.colors.gray[900]};
  }

  :active {
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.15);
    background-color: ${({ theme }) => theme.old.colors.white};
  }
`

export const icon = css`
  background-color: ${({ theme }) => theme.old.colors.gray[175]};
  display: grid;
  place-content: center;
  padding: 0;
  width: ${({ theme, size }) => theme.old.sizes.button[size]};
  min-width: ${({ theme, size }) => theme.old.sizes.button[size]};
  height: ${({ theme, size }) => theme.old.sizes.button[size]};
  color: ${({ theme }) => theme.old.colors.gray[700]};

  transition: border-width 0ms;

  border-color: ${({ theme }) => theme.old.colors.gray[225]};
  border-style: solid;
  border-width: 1px;

  :hover {
    border-width: 2px;
    color: ${({ theme }) => theme.old.colors.white};
  }
`

export const iconTransparent = css`
  ${icon}
  background-color: transparent;

  :hover {
    background-color: transparent;
  }
`

export const text = css`
  background-color: transparent;
  color: ${({ theme }) => theme.old.colors.primary};
  font-size: ${({ theme }) => theme.old.fonts.size.normal};
  font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
  padding: 2px;
  height: fit-content;

  :hover {
    color: ${({ theme }) => theme.old.colors.purple[600]};
  }
`